import { Component, Output, EventEmitter, Input } from '@angular/core';
import { MatDialog, MatSnackBar } from '@angular/material';
import { CrearProspectoDialog } from './crear-prospecto-dialog/crear-prospecto-dialog.component';
import { BotonTipo } from '../../../components/boton/boton';
import { AlertaContactoDialog } from '../../entidad/contactos/alerta-contacto/alerta-contacto/alerta-contacto-dialog.component';

@Component({
  selector: 'app-crear-prospecto',
  templateUrl: './crear-prospecto.component.html',
  styleUrls: ['./crear-prospecto.component.scss']
})
export class CrearProspectoComponent {
  @Input() type: BotonTipo;
  @Input() tooltipDir: string = 'below';
  @Output() onCerrado = new EventEmitter();

  constructor(
    public dialog: MatDialog
  ) { }

  ngOnInit() {
    if (!this.type) {
      throw "La variable Input 'type' es requerida";
    }
  }

  openDialog(): void {
    console.log('Open create Dato');
    let dialogCrear = this.dialog.open(CrearProspectoDialog, {
      disableClose: true

    });

    dialogCrear.afterClosed().subscribe(resultado => {
      this.onCerrado.emit();
    });
  }

  // openAlertaContactoDialog(): void {
  //   console.log('Open AlertaContactoDialog');
  //   let dialogAlerta = this.dialog.open(AlertaContactoDialog, {
  //     disableClose: true

  //   });
  //   dialogAlerta.afterClosed().subscribe(resultado => {
  //     this.openDialog();
  //   });
  // }
  openAlertaContactoDialog(): void {
    console.log('Open AlertaContactoDialog');
    const dialogAlerta = this.dialog.open(AlertaContactoDialog, {
      disableClose: true
    });
  
    dialogAlerta.componentInstance.onEliminar.subscribe(() => {
      console.log('Se seleccionó eliminar');
      // Realiza la acción correspondiente a eliminar aquí
      this.openDialog();
    });
  
    dialogAlerta.componentInstance.onCancelar.subscribe(() => {
      console.log('Se seleccionó cancelar');
      // No es necesario hacer nada aquí, el diálogo ya se cierra automáticamente
    });
  }

}
